import { MdOutlineEmail } from "react-icons/md";
import { useClientConfigProvider } from "../config/client-config-provider";
import SpinnerLoader from "./spinner-loader";
export function InputTextBox({
  isDisabled = false,
  isEditable = false,
  hasError = true,
  hint = "",
  suffix,
  isShowSuffix = false,
  showLoader = false,
  showCancelButton = false,
  ...props
}: any) {
  console.log("value in input field", {
    name: props.name,
    type: typeof props.name,
    hasError,
  });

  const handleClearInput = () => {
    if (props.onChange && typeof props.onChange === "function") {
      props.onChange({ target: { name: props.name, value: "" } });
    }
  };
  console.log("haserror", hasError);
  const handleScrollOrArrowKey = (e: any) => {
    console.log("scrolling or arrow key pressed");
    e.preventDefault();
    e.target.blur();

    // Prevent the page/container from scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };
  return (
    <div className="input-container">
      {/* <Image
        src={props.image}
        alt="Image"
        width="500"
        height="500"
        className="user-image"
      /> */}
      <div
        className={`d-flex input-box-v2 input ${hasError ? "error" : "inputfocus"}`}
        style={{
         
         
          background: `${
            isDisabled
              ? "var(--grey)"
              : "var(--LightTheme-Input-input_background)"
          }`,
         
        }}
      >
        <input
          onWheel={(e) => {
            handleScrollOrArrowKey(e);
          }}
          onKeyDown={(e) => {
            console.log("scrollingor", e.key);
            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
              handleScrollOrArrowKey(e);
            }
          }}
          disabled={isDisabled}
          type="text"
          placeholder={hint}
          style={{
            color: isDisabled
              ? "var(--LightTheme-Disable)"
              : "var(--LightTheme-Black-Black)",
            outline: "none",
            border: "none",
            width: "100%",
            background: isDisabled
              ? "transparent"
              : "var(--LightTheme-Input-input_background)",
          }}
          autoComplete="off"
          {...props}
        />
        <MdOutlineEmail className="email-icon-v2 email-icon-v2-new" 
        />

        {showCancelButton && props.value && (
          <div
            style={{ fontSize: "10px", cursor: "pointer" }}
            className="btn-close"
            onClick={handleClearInput}
          ></div>
        )}
        {showLoader && (
          <div className="suffix-btn" style={{ width: "30px", height: "30px" }}>
            <SpinnerLoader />
          </div>
        )}

        {suffix && isShowSuffix && <div className="suffix-btn">{suffix}</div>}
      </div>

      {hasError && (
        <></>
        // <div className="error-message" style={{ paddingLeft: "5px" }}>
        //   {/* <ErrorMessage className="error-message" name={props.name} /> */}
        //   {/* {errorMessage && <div className="error-message">{errorMessage}</div>} */}
        // </div>
      )}
    </div>
  );
}
